import { PathParamKeys } from 'app/core/workflow/page-path/path-param-keys';
import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class PersonalInfoChildSummaryComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return `statement/:${PathParamKeys.statementId}/children/personal-info/summary`;
  }
}
